import { GlobalDesignAction } from '../types';
import { getBaseManifestProcessingStrategy } from '../common/grouping/getBaseManifestProcessingStrategy';
import { shadowValueFilter } from './valueFilter';
import { shadowGrouping } from './grouping';
import ShadowLobbyItem from './ShadowLobbyItem';
import ShadowStyles from './ShadowStyles';

const shadowAction: GlobalDesignAction<'shadowStyles'> = {
  panel: ShadowStyles,
  lobbyItem: ShadowLobbyItem,
  getManifestProcessingStrategy: getBaseManifestProcessingStrategy,
  // TODO: remove comment after selection implementation
  // valueFilter: shadowValueFilter,
  grouping: shadowGrouping,
};

export default shadowAction;
